import BerichteVerwaltungDetailsKonfiguration from "./Konfiguration/Konfiguration.vue";

export default {
  BerichteVerwaltungDetailsKonfiguration,
};
